import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { TableCell, TableRow, IconButton, Tooltip } from '@mui/material'

import { Visibility } from '@mui/icons-material'
import { getDateForTable, getDateTimeFromIsoUTC } from '@/utils'
import { DrawersEnum, TimeZoneUTCType } from '@/enums'

import { dateTimeTableFormat } from '@/constants/date'
import { ContributionsLibraryColumnProps } from '@/state/transactions/models'
import useDrawer from '@/hooks/ui/use-drawer.hook'

type Props = {
  row: ContributionsLibraryColumnProps
}

export const ContributionsTableRow = ({ row }: Props) => {
  const { t } = useTranslation()

  const { handleToggleDrawer } = useDrawer()

  return (
    <TableRow hover>
      <TableCell>
        {row.placedDate !== '-'
          ? getDateForTable(
              `${format(
                getDateTimeFromIsoUTC(
                  row.placedDate,
                  TimeZoneUTCType['GMT-07 Pacific Time'],
                ),
                dateTimeTableFormat,
              )} PT`,
            )
          : row.placedDate}
      </TableCell>
      <TableCell>{row.betId || '-'}</TableCell>
      <TableCell>
        {t(`transaction.sportWagerStatusOptions.${row.status}`)}
      </TableCell>
      <TableCell>
        {t(`transaction.sportWagerTypeOptions.${row.betType}`)}
      </TableCell>
      <TableCell>{row.riskAmount}</TableCell>
      <TableCell>{row.winAmount}</TableCell>
      <TableCell>
        {row.wasRolloverAffected ? t('labels.true') : t('labels.false')}
      </TableCell>
      <TableCell>{row.rollOverAmount}</TableCell>
      <TableCell sx={{ position: 'sticky', right: 0, width: '50px' }}>
        {row.betDetails.length > 0 ? (
          <Tooltip arrow title={`${t('transaction.betDetails')}`}>
            <IconButton
              sx={{ borderRadius: '6px' }}
              size="small"
              onClick={() => {
                handleToggleDrawer({
                  open: true,
                  id: DrawersEnum.DRAWER_CONTRIBUTIONS_BET_DETAILS,
                  object: {
                    id: row.id,
                  },
                })
              }}
            >
              <Visibility fontSize="inherit" />
            </IconButton>
          </Tooltip>
        ) : (
          '-'
        )}
      </TableCell>
    </TableRow>
  )
}
